document.addEventListener('DOMContentLoaded', function () {
  let splide = new Splide('.splide', {
    gap: 26,
    perPage: 4,
    arrows: false,
    breakpoints: {
      768: {
        perPage: 1,
        arrows: true,
      },
    },
  });
  splide.mount();
});
